import {
  BeketPassengersValue,
  FormBeketPassengersValues,
} from 'entities/beket/models/form-passengers'

import { PassengerBeketOrder } from 'shared/api/beket/order'
import { TariffBeket, TariffBeketListType } from 'shared/constants'

const passengerKeys = [
  {
    key: 'dateOfBirth',
    prepare: 'date_of_birth',
  },
  {
    key: 'serialDocuments',
    prepare: 'document_number',
  },
]

interface Props {
  paxes: BeketPassengersValue[]
}

interface UpdateOrder {
  data: FormBeketPassengersValues | null
  citizenship?: {
    id: number
    name: string
  }[]
}

const prepareEachTariff = ({ paxes }: Props) => {
  return paxes?.map((passenger) => {
    // const citiName = citizenship?.find(
    //   (city) => String(city.id) === passenger.citizenship,
    // )?.id

    const preparedPassenger: PassengerBeketOrder = {
      citizenship: passenger.citizenship,
      last_name: passenger.lastName,
      first_name: passenger.firstName,
      tariff:
        passenger?.tariff || (TariffBeket.adult.key as TariffBeketListType),
    }

    passengerKeys?.forEach((keyPax) => {
      const paxKey = keyPax.key as keyof object

      if (passenger[paxKey]) {
        preparedPassenger[keyPax.prepare as keyof object] = passenger[paxKey]
      }
    })

    return preparedPassenger
  })
}

export const prepareDateUpdateOrder = ({ data }: UpdateOrder) => {
  if (!data) return null

  const preparedData: PassengerBeketOrder[] = prepareEachTariff({
    // citizenship,
    paxes: data?.adult,
  })

  const children = prepareEachTariff({
    // citizenship,
    paxes: data?.child,
  })

  return preparedData.concat(children)
}
